import {Injectable } from "@angular/core";

@Injectable() // Decorator that marks a class as available to be provided and injected as a dependency.
export class coursenavLanguage {

    CourseNavLanguages(){

        return [{
              type: "EN",
              one:{
                title:"Introduction",
                linktext:"Introduction",
              },
              two:{
                title:"Getting what you want",
                linktext:"Getting what you want",
              },
              three:{
                title:"Who do you want to be",
                linktext:"Who do you want to be",
              },
              four:{
                title:"Creating change – part 1 and 2",
                linktext:"Creating change – part 1 and 2",
              },
              five:{
                title:"Talking to the right people about the right things",
                linktext:"Talking to the right people about the right things",
              },
              six:{
                title:"Getting work",
                linktext:"Getting work",
              },
              seven:{
                title:"Getting your message across",
                linktext:"Getting your message across",
              },
              eight:{
                title:"Overcoming obstacles",
                linktext:"Overcoming obstacles",
              },
              nine:{
                title:"Choosing the right image",
                linktext:"Choosing the right image",
              },
              ten:{
                title:"Getting media coverage",
                linktext:"Getting media coverage",
              },
              eleven:{
                title:"Getting your message across online – part 1 and 2",
                linktext:"Getting your message across online – part 1 and 2",
              },
              twelve:{
                title:"Being visible online",
                linktext:"Being visible online",
              },
              thirteen:{
                title:"What next?",
                linktext:"What next?",
              },
              fourteen:{
                title:"Evaluation",
                linktext:"Evaluation",
              }
        },
        {
            type: "SV",
            one:{
                title:"Introduktion",
                linktext:"Introduktion",
              },
              two:{
                title:"Få vad du vill",
                linktext:"Få vad du vill",
              },
              three:{
                title:"Vem vill du vara",
                linktext:"Vem vill du vara",
              },
              four:{
                title:"Skapa förändring - del 1 och 2",
                linktext:"Skapa förändring - del 1 och 2",
              },
              five:{
                title:"Prata med rätt personer om rätt saker",
                linktext:"Prata med rätt personer om rätt saker",
              },
              six:{
                title:"Att få arbete",
                linktext:"Att få arbete",
              },
              seven:{
                title:"Förmedla ditt budskap",
                linktext:"Förmedla ditt budskap",
              },
              eight:{
                title:"Överkomma hinder",
                linktext:"Överkomma hinder",
              },
              nine:{
                title:"Välja rätt bild",
                linktext:"Välja rätt bild",
              },
              ten:{
                title:"Få mediebevakning",
                linktext:"Få mediebevakning",
              },
              eleven:{
                title:"Förmedla ditt budskap online - del 1 och 2",
                linktext:"Förmedla ditt budskap online - del 1 och 2",
              },
              twelve:{
                title:"Att vara synlig online",
                linktext:"Att vara synlig online",
              },
              thirteen:{
                title:"Vad händer härnäst?",
                linktext:"Vad händer härnäst?",
              },
              fourteen:{
                title:"Utvärdering",
                linktext:"Utvärdering",
              }
        },
        {
            type: "PL",
            one:{
                title:"Wprowadzenie",
                linktext:"Wprowadzenie",
              },
              two:{
                title:"Wiedz czego chcesz i osiągnij to",
                linktext:"Wiedz czego chcesz i osiągnij to",
              },
              three:{
                title:"Kim chcesz być?",
                linktext:"Kim chcesz być?",
              },
              four:{
                title:"Tworzenie zmiany - część 1 i 2",
                linktext:"Tworzenie zmiany - część 1 i 2",
              },
              five:{
                title:"RRozmawianie z właściwymi ludźmi o właściwych rzeczach ",
                linktext:"Rozmawianie z właściwymi ludźmi o właściwych rzeczach",
              },
              six:{
                title:"Zdobywanie pracy",
                linktext:"Zdobywanie pracy",
              },
              seven:{
                title:"Docieranie z wiadomością / Rozsiewanie informacji",
                linktext:"Docieranie z wiadomością / Rozsiewanie informacji",
              },
              eight:{
                title:"Pokonywanie przeszkód",
                linktext:"Pokonywanie przeszkód",
              },
              nine:{
                title:"Wybór właściwego wizerunku",
                linktext:"Wybór właściwego wizerunku",
              },
              ten:{
                title:"Zaistnieć w mediach",
                linktext:"Zaistnieć w mediach",
              },
              eleven:{
                title:"Przebicie się z informacjami on-line - część 1 i 2",
                linktext:"Przebicie się z informacjami on-line - część 1 i 2",
              },
              twelve:{
                title:"Bycie widoczną on-line",
                linktext:"Bycie widoczną on-line",
              },
              thirteen:{
                title:"Co dalej?",
                linktext:"Co dalej?",
              },
              fourteen:{
                title:"Ocena",
                linktext:"Ocena",
              }
        },
        {
            type: "DE",
            one:{
                title:"Einführung",
                linktext:"Einführung",
              },
              two:{
                title:"Ziele erreichen",
                linktext:"Ziele erreichen",
              },
              three:{
                title:"Wer möchten Sie sein?",
                linktext:"Wer möchten Sie sein?",
              },
              four:{
                title:"Veränderung schaffen - Teil 1 und 2",
                linktext:"Veränderung schaffen - Teil 1 und 2",
              },
              five:{
                title:"Mit den richtigen Leuten über die richtigen Dinge sprechen",
                linktext:"Mit den richtigen Leuten über die richtigen Dinge sprechen",
              },
              six:{
                title:"Aufträge bekommen",
                linktext:"Aufträge bekommen",
              },
              seven:{
                title:"Vermittlung Ihrer Botschaft",
                linktext:"Vermittlung Ihrer Botschaft",
              },
              eight:{
                title:"Hindernisse überwinden",
                linktext:"Hindernisse überwinden",
              },
              nine:{
                title:"Das richtige Bild auswählen",
                linktext:"Das richtige Bild auswählen",
              },
              ten:{
                title:"Medienaufmerksamkeit gewinnen",
                linktext:"Medienaufmerksamkeit gewinnen",
              },
              eleven:{
                title:"Vermittlung Ihrer Nachricht online - Teil 1 und 2",
                linktext:"Vermittlung Ihrer Nachricht online - Teil 1 und 2",
              },
              twelve:{
                title:"Online sichtbar sein",
                linktext:"Online sichtbar sein",
              },
              thirteen:{
                title:"Und was jetzt?",
                linktext:"Und was jetzt?",
              },
              fourteen:{
                title:"Auswertung",
                linktext:"Auswertung",
              }
        },
        {
            type: "FR",
            one:{
                title:"Introduction",
                linktext:"Introduction",
              },
              two:{
                title:"Obtenir ce que vous voulez",
                linktext:"Obtenir ce que vous voulez",
              },
              three:{
                title:"Qui voulez-vous être? ",
                linktext:"Qui voulez-vous être? ",
              },
              four:{
                title:"Créer le changement - partie 1 et 2",
                linktext:"Créer le changement - partie 1 et 2",
              },
              five:{
                title:"Parler aux bonnes personnes des bonnes choses",
                linktext:"Parler aux bonnes personnes des bonnes choses",
              },
              six:{
                title:"Travailler",
                linktext:"Travailler",
              },
              seven:{
                title:"Faire passer votre message",
                linktext:"Faire passer votre message",
              },
              eight:{
                title:"Surmonter les obstacles",
                linktext:"Surmonter les obstacles",
              },
              nine:{
                title:"Choisir la bonne image",
                linktext:"Choisir la bonne image",
              },
              ten:{
                title:"Obtenir une couverture médiatique",
                linktext:"Obtenir une couverture médiatique",
              },
              eleven:{
                title:"Faire passer votre message en ligne  - partie 1 et 2",
                linktext:"Faire passer votre message en ligne  - partie 1 et 2",
              },
              twelve:{
                title:"Être visible en ligne",
                linktext:"Être visible en ligne",
              },
              thirteen:{
                title:"Et ensuite?",
                linktext:"Et ensuite?",
              },
              fourteen:{
                title:"Évaluation",
                linktext:"Évaluation",
              }
        },
        {
            type: "SP",
            one:{
                title:"Introducción",
                linktext:"Introducción",
              },
              two:{
                title:"Conseguir lo que quieres",
                linktext:"Conseguir lo que quieres",
              },
              three:{
                title:"¿Quién quieres ser?",
                linktext:"¿Quién quieres ser?",
              },
              four:{
                title:"Creando cambio - parte 1 y 2",
                linktext:"Creando cambio - parte 1 y 2",
              },
              five:{
                title:"Hablar a las personas adecuadas sobre las cosas adecuadas.",
                linktext:"Hablar a las personas adecuadas sobre las cosas adecuadas.",
              },
              six:{
                title:"Conseguir trabajo",
                linktext:"Conseguir trabajo",
              },
              seven:{
                title:"Hacer llegar tu mensaje",
                linktext:"Hacer llegar tu mensaje",
              },
              eight:{
                title:"Superar obstáculos",
                linktext:"Superar obstáculos",
              },
              nine:{
                title:"Elegir la imagen adecuada",
                linktext:"Elegir la imagen adecuada",
              },
              ten:{
                title:"Conseguir cobertura mediática",
                linktext:"Conseguir cobertura mediática",
              },
              eleven:{
                title:"Hacer llegar tu mensaje online - parte 1 y 2",
                linktext:"Hacer llegar tu mensaje online - parte 1 y 2",
              },
              twelve:{
                title:"Ser visible online.",
                linktext:"Ser visible online.",
              },
              thirteen:{
                title:"¿Y ahora qué? ",
                linktext:"¿Y ahora qué? ",
              },
              fourteen:{
                title:"Evaluación",
                linktext:"Evaluación",
              }
        }
    ]

    }

    public getCourseNavLanguageText(langtyp:string){
        if(!langtyp){
          langtyp="EN";
        };
        let formlang = this.CourseNavLanguages().find(i => i.type === langtyp);
        return formlang;

      }
}
